import React from 'react';

type EditIconProps = {
  className?: string;
  onClick?: () => void;
  size?: number;
  color?: string | undefined;
  strokeWidth?: number
};

const RemoveIcon = ({ color = '#292D32', size = 19 }: EditIconProps) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.93945 16.5C13.0645 16.5 16.4395 13.125 16.4395 9C16.4395 4.875 13.0645 1.5 8.93945 1.5C4.81445 1.5 1.43945 4.875 1.43945 9C1.43945 13.125 4.81445 16.5 8.93945 16.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.93945 9H11.9395" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default RemoveIcon;